import { Injectable } from '@angular/core';
import { LoggingService } from '../../logging/logic/logging.service';
import { ActionHandler, ActionHandlerType } from '../action-handler';
import { TourService } from '../../tour/logic/tour.service';
import { ClientStateService } from '../../client-state/logic/client-state.service';
import { AppService } from '../../app-service/logic/app.service';
import { CredentialsService } from '../../credentials/logic/credentials.service';
import { RemoteActionService } from '../../remote-action/logic/remote-action.service';
import { ServicejobsService } from '../../servicejobs/logic/servicejobs.service';
import { LogTerminalConnectionProblemRemoteActionBuilder } from 'src/app/_model/remote-action/remote-action-builder/log-terminal-connection-problem-remote-action-builder/log-terminal-connection-problem-remoteaction-builder';

@Injectable({
  providedIn: 'root',
})
export class LogTerminalConnectionProblemActionHandler
  implements ActionHandler
{
  // Public Member
  public readonly name: ActionHandlerType = 'logterminalconnectionproblem';

  // Lifecycle
  constructor(
    private logger: LoggingService,
    private appService: AppService,
    private credentialService: CredentialsService,
    private remoteActionService: RemoteActionService,
    private clientStateService: ClientStateService,
  ) {}

  // ActionHandler
  public async executeAction(params?: any): Promise<any> {
    if (params == undefined) {
      return;
    }
    const state = this.clientStateService.theState.getValue();
    if (state.tourId == undefined) {
      return;
    }
    console.log(
      'JBLogTerminal executeAction with params',
      JSON.stringify(params),
    );
    const rab = new LogTerminalConnectionProblemRemoteActionBuilder(
      state.tourId.imsId,
      params.terminalId,
      params.terminalError,
      this.appService,
      this.credentialService,
      this.logger,
    );
    const ra = await rab.generateRemoteAction([]);
    await this.remoteActionService.sendRemoteAction(ra);
  }
}
